import AccordionDetails from "@mui/material/AccordionDetails"
import {DateRangeHeaderText} from "../../../common/components/report-page/DateRangeHeaderText"
import {GraphHelper} from "../../../common/components/report-page/GraphHelper"
import {LanguageBar} from "../../../common/components/LanguageBar"
import {Grid} from "@material-ui/core"
import {theme} from "../../../../../styles/MuiThemes"
import {DistributionChart} from "../../../common/components/aggregate-charts/DistributionChart"
import {AvantExpansionPanel} from "../../../../generic-components/AvantExpansionPanel"
import React from "react"
import {PrintOptions} from "../../../common/components/PrintViewContainer"
import {useReportUrlFilters} from "../../../common/hooks/useReportUrlFilters"
import {reportsStore} from "../../../common/stores/ReportStore"
import {Box} from "@mui/material"

export const ReportGraphSummary = ({printOptions}: {printOptions: PrintOptions | undefined}) => {

    /** ReportFilters assumes startDate and endDate to be non-null
     *  useReportUrlFilters hook does not make this assumption, but for backwards compatibility, use the old type */
    const reportUrlFilters = useReportUrlFilters()

    return (
        <AvantExpansionPanel
            expanded={printOptions != null ? true : undefined}
            title={"Summary"}
            sx={{margin: 0}}
        >
            <AccordionDetails
                style={{
                    width: "100%",
                    display: "inherit",
                    padding: printOptions != null ? 0 : ""
                }}
            >
                <Grid>
                    <DateRangeHeaderText
                        header={"Distribution of Test Takers Across Levels"}
                        from={reportUrlFilters.startDate}
                        to={reportUrlFilters.endDate}
                    />
                    <GraphHelper/>
                </Grid>
                {reportsStore?.reportGraphData?.graphs?.map?.(languageSummaryData => {
                    return (
                        <Box key={languageSummaryData.language} style={{breakInside: "avoid"}}>
                            <LanguageBar language={languageSummaryData.language}/>
                            <Grid
                                container={true}
                                justify={"space-between"}
                                style={{width: "100%", marginTop: theme.spacing(2)}}
                            >
                                {languageSummaryData.summarySkillGraph.map(skillGraph => {
                                    return <DistributionChart
                                        skillData={skillGraph}
                                        productId={reportUrlFilters.productId}
                                        key={skillGraph.skillName}
                                    />
                                })}
                            </Grid>
                        </Box>
                    )
                })}
            </AccordionDetails>
        </AvantExpansionPanel>

    )
}